import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Process', href: '/process' },
    { name: 'Sustainability', href: '/sustainability' },
    // { name: 'News', href: '/insights' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out bg-white ${
        isScrolled ? 'shadow-sm' : 'shadow-none'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_2d31ec28-4a6c-40e1-b5d9-0aecc911288e/artifacts/j2qgbysz_cdjk0bag_Asset%209.png"
              alt="Grenew"
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-300 ease-out ${
                  isActive(link.href)
                    ? 'text-[#4fd1c5]'
                    : 'text-gray-600 hover:text-[#0a1628]'
                }`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/contact"
              className={`px-5 py-2.5 text-sm font-semibold transition-all duration-300 ease-out bg-[#0a1628] text-white hover:bg-[#4fd1c5] hover:text-[#0a1628]`}
              data-testid="header-cta"
            >
              Request Pickup
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-[#0a1628] transition-colors duration-300" />
            ) : (
              <Menu className="w-6 h-6 text-[#0a1628] transition-colors duration-300" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden bg-white overflow-hidden transition-all duration-500 ease-out ${
        isMobileMenuOpen ? 'max-h-96 border-t' : 'max-h-0'
      }`}>
        <div className="px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className={`block py-3 text-base font-medium border-b border-gray-100 transition-colors duration-300 ${
                isActive(link.href) ? 'text-[#4fd1c5]' : 'text-gray-600'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/contact"
            className="block mt-4 py-3 bg-[#0a1628] text-white text-center font-semibold"
          >
            Request Pickup
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
